
import './App.css';
import {ReactComponent as BrightlifyLogo} from './images/BrightlifyLogoWhite.svg'

function App() {
  return (
    <div className="App">

      <div className="logoContainer">
        <BrightlifyLogo/>
      </div>

      <p>Web presence made easy.</p>
      <button>JOIN OUR WAITLIST</button>

    </div>
  );
}

export default App;
